import { Activity, User } from "@outschool/gql-backend-generated";

// Hack: copying these for now until we have an actual library for these
export function isFlexSchedule(
  activity: Pick<Activity, "weekly_meetings" | "duration_weeks">
) {
  return !activity?.weekly_meetings && !!activity?.duration_weeks;
}

export function isSellerOrg(leader?: { ownerOfSellerOrg?: any }) {
  return !!leader?.ownerOfSellerOrg;
}

export function isClub(activity: Pick<Activity, "isClub">) {
  return activity.isClub;
}

export const TUTORING_SUBJECTS = [
  "Math",
  "English",
  "Science & Nature",
  "Social Studies",
  "Test Prep",
];
export const COACHING_SUBJECTS = ["Life Skills", "Health & Wellness"];
export const LESSON_SUBJECTS = [
  "Music",
  "Arts",
  "World Languages",
  "Coding & Tech",
  "Games & Hobbies",
  "Early Education",
];

export function isAdmin(user: Pick<User, "is_admin">) {
  return !!(user && user.is_admin);
}

export const isOwner = (
  activity: Pick<Activity, "user_uid">,
  user: Pick<User, "uid">
) => Boolean(user) && activity.user_uid === user.uid;

export const isOneOnOne = (
  activity: Pick<Activity, "size_max" | "isSelfPaced">
) => activity.size_max === 1 && !activity.isSelfPaced;
